import React, { useState } from "react";
import EntitySelector from "Explore/Pages/Analysis/Components/EntitySelector/EntitySelector";
import { X } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "components/ui/avatar";

const PeerEntitySelector = ({ selectedEntity, onSelect, onClear }) => {
  // Wrap the Analysis EntitySelector to only allow one entity
  const handleEntitiesChange = (hasChanges, entities) => {
    if (entities && entities.length > 0) {
      // Always take the last selected entity to enforce single selection
      const newEntity = entities[entities.length - 1];
      onSelect(newEntity);
    }
  };

  const logoUrl = (selectedEntity?.id ? `https://media.academic.online/institutions_images/${selectedEntity.id}/seal.png` : null) || selectedEntity?.photo || selectedEntity?.avatar || selectedEntity?.logo || selectedEntity?.logo_url;

  return (
    <div className="w-full">
      {selectedEntity ? (
        <div className="flex items-center gap-3 p-3 bg-blue-50/50 border border-blue-100 rounded-lg w-full">
          <Avatar className="h-10 w-10 shrink-0 rounded-lg bg-white border border-blue-200 shadow-sm p-0.5">
            <AvatarImage
              src={logoUrl}
              alt={selectedEntity.name}
              className="object-contain"
            />
            <AvatarFallback className="bg-explore/5 text-explore font-bold rounded-md text-xs">
              {selectedEntity.name?.substring(0, 2).toUpperCase() || "UN"}
            </AvatarFallback>
          </Avatar>
          <div className="flex flex-col flex-1 min-w-0">
            <span className="text-sm font-semibold text-slate-900 truncate">
              {selectedEntity.name}
            </span>
            <span className="text-xs text-slate-500 capitalize">
              {selectedEntity.type || "Institution"}
            </span>
          </div>
          <button
            onClick={onClear}
            className="p-1.5 text-slate-400 hover:text-slate-600 hover:bg-white rounded-md transition-colors"
            title="Clear selection"
          >
            <X size={16} />
          </button>
        </div>
      ) : (
        <div className="w-full flex flex-col items-center">
          <div className="w-full relative">
            <EntitySelector
              selectedEntities={[]}
              onPendingChange={handleEntitiesChange}
              onEntitiesClear={onClear}
              allowedTypes={["institution"]}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default PeerEntitySelector;
